import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import ProfessionalDevelopment from "./components/ProfessionalDevelopment"
import Resources from "./components/Resources"
import { unregister } from "./registerServiceWorker"
import { createStore, applyMiddleware, compose } from "redux"
import { Provider } from "react-redux"
import thunk from "redux-thunk"
import rootReducer from "./reducers/index"
import createHistory from "history/createBrowserHistory"
import { Route, Switch } from "react-router"
import { ConnectedRouter, routerMiddleware } from "react-router-redux"
import PrimaryProfessionalDevelopment from "./components/PrimaryProfessionalDevelopment"
import SecondaryProfessionalDevelopment from "./components/SecondaryProfessionalDevelopment"
import ResourcesPrimary1 from "./components/ResourcesPrimary1"
import ResourcesPrimary2 from "./components/ResourcesPrimary2"
import ResourcesPrimary3 from "./components/ResourcesPrimary3"
import ResourcesPrimary4 from "./components/ResourcesPrimary4"
import ResourcesPrimary5 from "./components/ResourcesPrimary5"
import ResourcesPrimary6 from "./components/ResourcesPrimary6"
import ResourcesPrep1 from "./components/ResourcesPrep1"
import ResourcesPrep2 from "./components/ResourcesPrep2"
import ResourcesPrep3 from "./components/ResourcesPrep3"
import ResourcesSecondary1 from "./components/ResourcesSecondary1"
import ResourcesSecondary2 from "./components/ResourcesSecondary2"
import ResourcesSecondary3 from "./components/ResourcesSecondary3"
import CategoryList from "./components/CategoryList"
import PostList from "./components/PostList"
import Post from "./components/Post"
import NewPost from "./components/NewPost"
import NewCategory from "./components/NewCategory"
import PhotosView from "./components/PhotosView"
import ScrollToTop from "./components/ScrollToTop"
import PasswordReset from "./components/PasswordReset"
import PasswordUpdate from "./components/PasswordUpdate"
import PrivacyPolicy from "./components/PrivacyPolicy"
import ResourcesSuspended from "./components/ResourcesSuspended"

const history = createHistory()

const middleware = routerMiddleware(history)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, middleware))
)

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ScrollToTop>
        <div>
          <Switch>
            <Route
              exact
              path="/professional-development"
              component={ProfessionalDevelopment}
            />
            <Route exact path="/resources" component={Resources} />
            <Route exact path="/privacy-policy" component={PrivacyPolicy} />
            <Route
              exact
              path="/professional-development-primary"
              component={PrimaryProfessionalDevelopment}
            />
            <Route
              exact
              path="/professional-development-secondary"
              component={SecondaryProfessionalDevelopment}
            />
            <Route
              exact
              path="/resources-primary-1"
              component={ResourcesPrimary1}
            />
            <Route
              exact
              path="/resources-primary-2"
              component={ResourcesPrimary2}
            />
            <Route
              exact
              path="/resources-primary-3"
              component={ResourcesPrimary3}
            />
            <Route
              exact
              path="/resources-primary-4"
              component={ResourcesPrimary4}
            />
            <Route
              exact
              path="/resources-primary-5"
              component={ResourcesPrimary5}
            />
            <Route
              exact
              path="/resources-primary-6"
              component={ResourcesPrimary6}
            />
            <Route exact path="/resources-prep-1" component={ResourcesPrep1} />
            <Route exact path="/resources-prep-2" component={ResourcesPrep2} />
            <Route exact path="/resources-prep-3" component={ResourcesPrep3} />
            <Route
              exact
              path="/resources-secondary-1"
              component={ResourcesSecondary1}
            />
            <Route
              exact
              path="/resources-secondary-2"
              component={ResourcesSecondary2}
            />
            <Route
              exact
              path="/resources-secondary-3"
              component={ResourcesSecondary3}
            />
            <Route
              exact
              path="/resources-suspended"
              component={ResourcesSuspended}
            />
            <Route exact path="/forum" component={CategoryList} />
            <Route exact path="/photos" component={PhotosView} />
            <Route exact path="/new-topic" component={NewPost} />
            <Route exact path="/add-category" component={NewCategory} />
            <Route exact path="/password-reset" component={PasswordReset} />
            <Route exact path="/password-update" component={PasswordUpdate} />
            <Route exact path="/:category" component={PostList} />
            <Route exact path="/post/:postID" component={Post} />
            <Route exact path="/" component={App} />
          </Switch>
        </div>
      </ScrollToTop>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
)

// registerServiceWorker();
unregister()



// WEBPACK FOOTER //
// ./src/index.js